import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classes } from "./classes.js";
export function Table({ caption, captionVisible = false, children }) {
    return (_jsxs("table", { className: "table", children: [_jsx("caption", { className: classes(!captionVisible && "wt-visually-hidden"), children: caption }), children] }));
}
export function TableHead({ children }) {
    return _jsx("thead", { children: children });
}
export function TableBody({ children }) {
    return _jsx("tbody", { children: children });
}
export function TableRow({ children }) {
    return _jsx("tr", { children: children });
}
export function TableHeaderCell({ numeric = false, children }) {
    return (_jsx("th", { scope: "col", className: classes(numeric && "wt-numeric"), children: children }));
}
export function TableCell({ numeric = false, font = "body", children }) {
    return _jsx("td", { className: classes(numeric && "wt-numeric", font === "mono" && "wt-mono"), children: children });
}
//# sourceMappingURL=table.js.map